import React, { useEffect, useState } from 'react';
import { WEB_SMALL_DIALOG_MAX_WIDTH } from '../../theme/webLayoutWidths';
import { Modal, Platform, Pressable, StyleSheet } from 'react-native';
import { Button } from 'react-native-paper';
import Typography from '../Reusables/Typography';
import { useTheme } from '../../theme';

declare global {
  interface Window {
    electronAPI?: {
      getAppInfo: () => Promise<{ name: string; version: string }>;
    };
  }
}

export default function ElectronAboutModal() {
  const { theme } = useTheme();
  const [visible, setVisible] = useState(false);
  const [appInfo, setAppInfo] = useState<{
    name: string;
    version: string;
  } | null>(null);

  useEffect(() => {
    if (Platform.OS !== 'web' || !window.electronAPI) return;

    const handler = () => {
      setVisible(true);
      window.electronAPI!.getAppInfo().then(setAppInfo);
    };

    window.addEventListener('electron-open-about', handler);
    return () => window.removeEventListener('electron-open-about', handler);
  }, []);

  if (Platform.OS !== 'web' || !window.electronAPI) return null;

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={() => setVisible(false)}>
      <Pressable style={styles.overlay} onPress={() => setVisible(false)}>
        <Pressable
          style={[styles.content, { backgroundColor: theme.colors.surface }]}
          onPress={e => e.stopPropagation()}>
          <Typography style={[theme.typography.h5, { marginBottom: 8 }]}>
            {appInfo?.name ?? 'BizPlus POS'}
          </Typography>
          <Typography
            style={[
              theme.typography.body,
              { color: theme.colors.textSecondary, marginBottom: 16 },
            ]}>
            Version {appInfo?.version ?? '—'}
          </Typography>
          <Typography
            style={[
              theme.typography.bodySmall,
              { color: theme.colors.textSecondary, marginBottom: 24 },
            ]}>
            Manage inventory, track sales, and accept payments. Built for modern
            retail.
          </Typography>
          <Button mode="contained" onPress={() => setVisible(false)}>
            Close
          </Button>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  content: {
    borderRadius: 12,
    padding: 24,
    maxWidth: WEB_SMALL_DIALOG_MAX_WIDTH,
    width: '100%',
  },
});
